<template>
    <div>

        <template v-if="!setup">

            <config-main-title>
                Agendas
            </config-main-title>

            <div v-if="!em_edicao">

                <div class="row mb-3">
                    <div class="col col-12 col-md-3">
                        <az-input icon="fas fa-user-md fa-fw" 
                                buttonText="fas fa-user-md"
                                :buttonIcon="true"
                                buttonColor="outline-primary"
                                type="select" 
                                optionsMode="aql"
                                service="medicos.index"
                                optionsName="medicos-cadastro-ativos"
                                :optionsParm="{ ativos: true }"
                                v-model="medico" 
                                @input="load ()" 
                                @clickButton="abrirMedico()"/>
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="far fa-building fa-fw"
                            type="select"
                            placeholder="Todas"
                            :optionsList="$util.unidades_com_tags(false, true)"
                            optionsData="id_unidade_operacao"
                            v-model="unidade_operacao" 
                            @input="load ()" />
                    </div>
                    <div class="col col-12 col-md-3 d-flex flex-column">
                        <div class="btn-group mb-1" role="group" aria-label="Basic example">
                            <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                            @click="viewMode = 'A'">
                                Ativos
                            </button>
                            <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                            @click="viewMode = 'T'">
                                Todos
                            </button>
                        </div>
                    </div>
                    <div class="col col-12 col-md-3 d-flex flex-column">
                        <button type="button" class="btn btn-outline-success" @click="incluirAgendaGrupo ()">
                            Incluir Agenda
                        </button>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col col-12 col-md-3">

                        <az-input
                            type="date"
                            icon="fa fa-calendar-o"
                            buttonToolTip="Verificação das agendas válidas para a data selecionada."
                            @input="load_by_referencia()"
                            v-model="referencia" />

                    </div>

                    <div class="col col-12 col-md-6">

                        <az-input
                            ref="pesquisa" 
                            icon="fa fa-search"
                            v-model="search" />

                    </div>

                    <div class="col col-12 col-md-3 d-flex flex-column">
                        <button type="button" class="btn btn-outline-primary" @click="editar_encerramento ()">
                            Novo Período
                        </button>
                    </div>

                </div>

            </div>

            <div class="alert alert-info" v-if="!medico && unidades && unidades.length">
                <table class="table table-sm mb-0 table-hover small">
                    <tr>
                        <td colspan='2'>
                            Limite de Abertura de Agenda
                        </td>
                    </tr>
                    <tr v-for="(unid, iux) in unidades" :key="iux" 
                        :class="( unid.dt_limite_agenda_aberta && unid.dt_limite_agenda_aberta < $util.hoje() ) ? 'table-danger' : ''">
                        <td>{{ unid.st_nome }}</td>
                        <td>
                            <a href="#" @click.prevent="abrir_limite_agenda(unid)" class="alert-link">
                                {{ unid.dt_limite_agenda_aberta ? $util.getFormatDate(unid.dt_limite_agenda_aberta) : 'Não definido' }}
                            </a>

                            <span v-if="unid.dt_limite_agenda_aberta && unid.dt_limite_agenda_aberta < $util.hoje()"
                                class="ml-2"
                                title="Data passada.">
                                <i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>
                            </span>
                        </td>
                        <td>
                            <a href="#" @click.prevent="$util.logAudit('unidadeOperacao', unid.id_unidade_operacao, { campos: { id_unidade_operacao: true, dt_limite_agenda_aberta: true } })" class="card-link">
                                Log
                            </a>
                        </td>
                    </tr>
                </table>
            </div>

            <div v-if="!lista_filtrada || !lista_filtrada.length">
                <az-empty-state 
                    :msg="search ? 'Nenhuma agenda encontrada' : ( medico ? 'Nenhuma agenda registrada' : 'Selecione o médico' )" 
                    :icon="medico || search ? 'fas fa-search' : 'fas fa-user-md'"
                    :action="medico ? 'Incluir Agenda' : ''" 
                    :method="incluirAgendaGrupo" />
            </div>

            <div v-if="!em_edicao && lista_filtrada && lista_filtrada.length">

                <template  v-for="(items, nome_medico, idx) in lista">

                    <div class="card dashcard mb-3" :key="'c' + idx" v-if="true"> 
                        <div class="card-header bg-primary text-white" :key="'m' + idx">
                            <a href="#" @click.prevent="medico ? ( medico = '' ) : medico_inicial(null, items[0].id_medico)" class="card-link text-white">
                                {{ nome_medico }}
                            </a>
                        </div>
                        <template v-for="(dado, id) in items">
                            <div class="card-header bg-light" :key="'h' + idx + '-' + id" v-if="true">
                                <div class="d-flex justify-content-between">
                                    <span class="d-flex align-items-center">
                                        <a data-toggle="collapse" :href="'#collapse-' + idx + '-' + id" class="h5 card-link mb-0 mr-3"
                                            v-if="dado.agenda"
                                            :class="dado.fl_ativo && dado.dt_vigencia_termino >= $util.hoje() ? '' : 'text-secondary'">
                                            {{ dado.search }}
                                        </a>
                                        <span class="h5 mb-0 mr-3" v-else
                                            :class="dado.fl_ativo && dado.dt_vigencia_termino >= $util.hoje() ? '' : 'text-muted'">
                                            {{ dado.search }}
                                        </span>

                                        <big data-toggle="tooltip" data-placement="top" title="Agenda para data futura" 
                                            v-if="dado.dt_vigencia_inicio > $util.hoje()">
                                            <i class="fas fa-plane-departure mr-2"></i>
                                        </big>
                                        <big data-toggle="tooltip" data-placement="top" title="Agenda já passada" 
                                            v-if="dado.dt_vigencia_termino < $util.hoje()">
                                            <i class="fas fa-history mr-2"></i>
                                        </big>
                                        <big data-toggle="tooltip" data-placement="top" title="Agenda Eventual" v-if="dado.fl_eventual">
                                            <i class="fas fa-calendar-day mr-2"></i>
                                        </big>
                                        <big data-toggle="tooltip" data-placement="top" title="Datas Específicas" v-if="dado.fl_listar_datas">
                                            <i class="fa-solid fa-calendar-check mr-2"></i>
                                        </big>
                                        <small class="ml-1" v-if="dado.st_observacoes">{{ dado.st_observacoes }}</small>
                                    </span>
                                    <span class="d-flex align-items-center">
                                        <template v-if="dado.agenda">
                                            <span class="badge badge-secondary mr-2" 
                                                data-toggle="tooltip" data-placement="top" title="Agendas no período."
                                                v-if="dado.agenda && dado.agenda.length">
                                                {{ dado.agenda.length }}
                                            </span>
                                            <span v-else
                                                data-toggle="tooltip" data-placement="top" title="Nenhuma agenda nesse período.">
                                                <i class="fa fa-exclamation-triangle text-warning mr-2" aria-hidden="true"></i>
                                            </span>
                                            <a href="#" @click.prevent="editarAgendaGrupo(dado)"
                                                data-toggle="tooltip" data-placement="top" title="Editar Período.">
                                                <i class="fas fa-pen ml-3"></i>
                                            </a>
                                            <a href="#" @click.prevent="editarAgendaGrupo(dado, true)" 
                                                data-toggle="tooltip" data-placement="top" title="Clonar Agenda">
                                                <i class="far fa-clone ml-3"></i>
                                            </a>
                                            <button type="button" class="btn btn-link btn-sm text-success ml-3" @click="comporAgenda (dado)"
                                                data-toggle="tooltip" data-placement="top" title="Criar Agenda">
                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                            </button>
                                        </template>
                                        <div class="custom-control custom-switch ml-3" v-if="viewMode == 'T'">
                                            <input type="checkbox" class="custom-control-input" 
                                                :id="'ativo-' + idx + '-' + id" 
                                                v-model="dado.fl_ativo" 
                                                @change="toggle(dado)">
                                            <label class="custom-control-label" :for="'ativo-' + idx + '-' + id"></label>
                                        </div>
                                    </span>
                                </div>
                                <div v-if="dado.dt_abertura && dado.dt_abertura > $util.hoje()">
                                    <small class="text-muted">
                                        Abetura {{ $util.getFormatDate(dado.dt_abertura) }}
                                    </small>
                                </div>
                            </div>
                            <div class="card-body collapse" :id="'collapse-' + idx + '-' + id" :key="'b' + idx + '-' + id" v-if="dado.agenda">
                                <div class="row px-2">
                                    <agenda-dia dia="SEG" :value="agendas (dado, 1)" @click="editar" v-if="agendas (dado, 1).length" />
                                    <agenda-dia dia="TER" :value="agendas (dado, 2)" @click="editar" v-if="agendas (dado, 2).length" />
                                    <agenda-dia dia="QUA" :value="agendas (dado, 3)" @click="editar" v-if="agendas (dado, 3).length" />
                                    <agenda-dia dia="QUI" :value="agendas (dado, 4)" @click="editar" v-if="agendas (dado, 4).length" />
                                    <agenda-dia dia="SEX" :value="agendas (dado, 5)" @click="editar" v-if="agendas (dado, 5).length" />
                                    <agenda-dia dia="SAB" :value="agendas (dado, 6)" @click="editar" v-if="agendas (dado, 6).length"/>
                                    <agenda-dia dia="DOM" :value="agendas (dado, 0)" @click="editar" v-if="agendas (dado, 0).length" />
                                    <!--
                                    <agenda-dia dia="SEG" :value="agendas (dado, 1)" @click="editar" v-if="!dado.eventual_dias || dado.eventual_dias.find(item => item == 1)" />
                                    <agenda-dia dia="TER" :value="agendas (dado, 2)" @click="editar" v-if="!dado.eventual_dias || dado.eventual_dias.find(item => item == 2)" />
                                    <agenda-dia dia="QUA" :value="agendas (dado, 3)" @click="editar" v-if="!dado.eventual_dias || dado.eventual_dias.find(item => item == 3)" />
                                    <agenda-dia dia="QUI" :value="agendas (dado, 4)" @click="editar" v-if="!dado.eventual_dias || dado.eventual_dias.find(item => item == 4)" />
                                    <agenda-dia dia="SEX" :value="agendas (dado, 5)" @click="editar" v-if="!dado.eventual_dias || dado.eventual_dias.find(item => item == 5)" />
                                    <agenda-dia dia="SAB" :value="agendas (dado, 6)" @click="editar" v-if="!dado.eventual_dias || dado.eventual_dias.find(item => item == 6)"/>
                                    <agenda-dia dia="DOM" :value="agendas (dado, 0)" @click="editar" v-if="!dado.eventual_dias || dado.eventual_dias.find(item => item == 0)" />
                                    -->
                                </div>

                                <div class="row mt-3">
                                    <div class="col col-12 d-flex justify-content-between">
                                        <div>
                                            <span class="badge badge-primary mr-2">Hora Marcada</span>
                                            <span class="badge badge-warning mr-2">Ordem de Chegada</span>
                                        </div>
                                        <div>
                                            <button type="button" class="btn btn-sm btn-outline-primary ml-1" v-if="!dado.fl_eventual && dado.fl_listar_datas" @click="informar_datas(dado)">
                                                <i class="fa-solid fa-calendar-check mr-2"></i>
                                                Informar Datas
                                            </button>
                                            <button type="button" class="btn btn-sm btn-outline-primary ml-1" v-if="dado.agenda && dado.agenda.length" @click="editar_agendas(dado)">
                                                Editar Agendas
                                            </button>
                                            <button type="button" class="btn btn-sm btn-outline-primary ml-1" v-if="dado.agenda && dado.agenda.length" @click="incluir_proced(dado)">
                                                Incluir Procedimentos
                                            </button>
                                            <button type="button" class="btn btn-sm btn-outline-danger ml-1" v-if="dado.agenda && dado.agenda.length" @click="incluir_proced(dado, false)">
                                                Remover Procedimentos
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="alert alert-secondary mt-3 mb-0" v-if="!dado.fl_eventual && dado.fl_listar_datas">
                                    <div class="row">
                                        <div class="col col-12 text-nowrap text-truncate">
                                            <span v-if="!dado.proximas_datas || !dado.proximas_datas.length">
                                                Nenhuma data informada.
                                            </span>
                                            <template v-else>
                                                {{ 
                                                    dado.proximas_datas.map(item => 
                                                        $util.getFormatDate(item.dt_data) + ' ' + $util.getFormatDate(item.dt_data, 'ddd')
                                                    ).join(', ') 
                                                }}
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </template>

            </div>

        </template>

        <!-- Modal de Nova Agenda Grupo -->
        <div class="modal fade" id="novaAgendaGrupoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" v-if="nova">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ nova.clone ? ( 'Clonar Agenda de ' + $util.getFormatDate(nova.base) ) : ( nova.id_agenda_grupo ? 'Editar Agenda' : 'Nova Agenda' ) }}
                            <span class="badge badge-secondary ml-2" v-if="nova && nova.id_agenda_grupo">#{{ nova.id_agenda_grupo }}</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="nova">
                        <div class="lead mb-3" v-if="nova.id_agenda_grupo">{{ nova.medico.search }}</div>

                        <div class="row"> 
                            <div class="col col-12">
                                <az-input 
                                    label="De"
                                    type="date"
                                    v-model="nova.dt_vigencia_inicio" 
                                    :edicao2="nova.clone || !nova.id_agenda_grupo"
                                    required 
                                    :validate="validate"/>
                            </div>
                        </div>
                        <div class="row"> 
                            <div class="col col-12">
                                <az-input 
                                    label="Até"
                                    type="date"
                                    v-model="nova.dt_vigencia_termino" 
                                    required 
                                    :validate="validate" />
                            </div>
                        </div>
                        <div class="row"> 
                            <div class="col col-12">
                                <az-input 
                                    label="Observações"
                                    type="textarea"
                                    v-model="nova.st_observacoes" 
                                    rows="3"
                                    :validate="validate" />
                            </div>
                        </div>
                        <div class="row" v-if="nova.dt_vigencia_inicio && nova.dt_vigencia_inicio > $util.hoje()"> 
                            <div class="col col-12">
                                <az-input 
                                    label="Data de Abertura da Agenda"
                                    type="date"
                                    v-model="nova.dt_abertura" 
                                    :validate="validate" />
                                <small class="text-muted">Data a partir da qual a agenda estará disponível para marcação. Sem preencher, a agenda estará disponível a partir do cadastro.</small>
                            </div>
                        </div>
                        <div class="row mt-3"> 
                            <div class="col col-12">
                                <az-input
                                    type="checkbox-group"
                                    label="Eventual"
                                    v-model="nova.fl_eventual" />
                            </div>
                        </div>
                        <div class="row" v-if="!nova.fl_eventual"> 
                            <div class="col col-12">
                                <az-input
                                    type="checkbox-group"
                                    label="Informar Datas"
                                    v-model="nova.fl_listar_datas" />
                            </div>
                        </div>

                        <div class="alert alert-info" v-if="!nova.fl_eventual && nova.fl_listar_datas">
                            Serão habilitadas agendas somente para datas listadas.
                        </div>

                        <!-- Clonar para outro profissional -->
                        <template v-if="nova.clone">

                            <div class="row mt-1"> 
                                <div class="col col-12">
                                    <az-input
                                        type="checkbox-group"
                                        label="Clonar para outro prestador"
                                        v-model="nova.clonar_para_outro" />
                                </div>
                            </div>

                            <div class="row" v-if="nova.clonar_para_outro"> 
                                <div class="col col-12">
                                    <az-input 
                                        label="Prestador"
                                        type="select" 
                                        optionsMode="aql"
                                        service="medicos.index"
                                        optionsName="medicos-cadastro-ativos"
                                        :optionsParm="{ ativos: true }"
                                        optionsData="id_pessoa"
                                        required
                                        :validate="validate"
                                        v-model="nova.id_medico" />
                                </div>
                            </div>

                        </template>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button v-if="nova && !nova.clone && nova.id_agenda_grupo" model="agendaGrupo" :id="nova.id_agenda_grupo" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="criarAgendaGrupo ()">{{ nova && nova.id_agenda_grupo ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Formulário de edição de agendas -->
        <div class="modal fade" id="agendaEdicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ ( item && item.id_agenda ) 
                                ? ( 'Edição de Agenda: ' + texto_do_dia(item.in_dia_semana) )  
                                : ( item.acao_proced == 'I' ? 'Incluir Procedimentos' : ( item.acao_proced == 'R' ? 'Remover Procedimentos' : 'Compor Agenda' ) ) }}

                            <span v-if="item.id_agenda" class="badge badge-secondary mx-2">
                                #{{ item.id_agenda }}
                            </span>

                            <span v-if="item.medico" class="badge badge-secondary">
                                {{ item.medico.st_nome_exibicao }}
                            </span>
                            <span v-if="item.ch_filtro_operadora && item.ch_filtro_operadora != 'T' && lista_operadoras_selecionadas.length" class="badge badge-warning ml-2">
                                Filtro Operadora / {{ item.ch_filtro_operadora == 'E' ? 'Exceto' : 'Apenas' }}
                                / 
                                <span v-if="lista_operadoras_selecionadas.length == 1">
                                    {{ lista_operadoras_selecionadas.map(oper => oper.search).join(', ') }}
                                </span>
                                <span v-else>
                                    {{ lista_operadoras_selecionadas.length }} Operadoras
                                </span>
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <template v-if="!item.id_agenda && item.acao_proced != 'C'">
                            <div class="row my-2">
                                <div class="col col-12 d-flex flex-column">
                                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                                        <button type="button" class="btn" 
                                            :class="dia.selecionado ? 'btn-secondary' : 'btn-outline-secondary'" 
                                            @click="dia.selecionado = !dia.selecionado"
                                            v-for="(dia, idia) in dias_com_agenda(item.dias)" :key="idia">
                                            {{ dia.nome }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!-- Compor Nova Agenda -->
                        <template v-else>
                            <div v-if="!item.id_agenda">
                                <div class="form-row mb-2" v-if="!item.id_agenda">
                                    <div class="col col-12 d-flex flex-column">
                                        <div class="btn-group mb-1" role="group" aria-label="Basic example">
                                            <button type="button" class="btn" 
                                                :class="!item.fl_ordem_chegada ? 'btn-secondary' : 'btn-outline-secondary'" 
                                                @click="item.fl_ordem_chegada = false">
                                                Hora Marcada
                                            </button>
                                            <button type="button" class="btn" 
                                                :class="item.fl_ordem_chegada ? 'btn-secondary' : 'btn-outline-secondary'" 
                                                @click="item.fl_ordem_chegada = true">
                                                Ordem de Chegada
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col col-12">
                                        <az-input 
                                            label="Título"
                                            placeholder="Título (Opcional)..."
                                            v-model="item.st_titulo" />
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col col-12 col-md-3">
                                        <az-input 
                                            type="time" 
                                            label="Hora Início"
                                            v-model="item.hr_inicio" 
                                            required 
                                            :validate="validate"/>
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input 
                                            type="time" 
                                            label="Hora Término"
                                            v-model="item.hr_termino" 
                                            required 
                                            :validate="validate"/>
                                    </div>
                                    <div class="col col-12" :class="( vagas_por_horario && !item.fl_ordem_chegada ) ? 'col-md-2' : 'col-md-3'">
                                        <az-input 
                                            type="number" 
                                            label="Tempo de Atendimento"
                                            v-model="item.in_tempo_atendimento" 
                                            required 
                                            :validate="validate" 
                                            v-if="!item.fl_ordem_chegada" />
                                        <az-input 
                                            type="number" 
                                            label="Quantidade de Pacientes"
                                            v-model="item.in_tempo_atendimento" 
                                            required 
                                            :validate="validate" 
                                            v-else />
                                    </div>
                                    <div class="col col-12" :class="vagas_por_horario ? 'col-md-2' : 'col-md-3'">
                                        <az-input 
                                            type="number" 
                                            label="Extras"
                                            v-model="item.in_vagas_extras" 
                                            :validate="validate" 
                                            v-if="!item.fl_ordem_chegada" />
                                    </div>
                                    <div class="col col-12 col-md-2" v-if="vagas_por_horario && !item.fl_ordem_chegada">
                                        <az-input 
                                            placeholder="1..."
                                            type="number" 
                                            label="Vagas por Horário"
                                            v-model="item.in_vagas_por_horario" 
                                            :validate="validate" />
                                    </div>
                                </div>
                                <div class="form-row my-2">
                                    <div class="col col-12 d-flex flex-column">
                                        <div class="btn-group mb-1" role="group" aria-label="Basic example">
                                            <button type="button" class="btn" 
                                                :class="dia.selecionado ? 'btn-secondary' : 'btn-outline-secondary'" 
                                                @click="dia.selecionado = !dia.selecionado"
                                                v-for="(dia, idia) in item.dias" :key="idia">
                                                {{ dia.nome }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Edição de Agenda -->
                            <div v-else>
                                <div class="form-row">
                                    <div class="col col-12">
                                        <az-input 
                                            label="Título"
                                            placeholder="Título (Opcional)..."
                                            v-model="item.st_titulo" />
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col col-12 col-md-3">
                                        <az-input 
                                            label="Hora Início"
                                            type="time"
                                            required
                                            v-model="item.hora_inicio" 
                                            @input="checar_conflito_local(item)" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input 
                                            label="Hora Término"
                                            type="time"
                                            required
                                            v-model="item.hora_termino" 
                                            @input="checar_conflito_local(item)" />
                                    </div>
                                    <div class="col col-12" :class="( vagas_por_horario && !item.fl_ordem_chegada ) ? 'col-md-2' : 'col-md-3'">
                                        <az-input 
                                            type="number" 
                                            label="Tempo de Atendimento"
                                            v-model="item.in_tempo_atendimento" 
                                            required 
                                            :validate="validate" 
                                            v-if="!item.fl_ordem_chegada" />
                                        <az-input 
                                            type="number" 
                                            label="Quantidade de Pacientes"
                                            v-model="item.in_tempo_atendimento" 
                                            required 
                                            :validate="validate" 
                                            v-else />
                                    </div>
                                    <div class="col col-12" :class="( vagas_por_horario && !item.fl_ordem_chegada ) ? 'col-md-2' : 'col-md-3'">
                                        <az-input 
                                            type="number" 
                                            label="Extras"
                                            v-model="item.in_vagas_extras" 
                                            :validate="validate"/>
                                    </div>
                                    <div class="col col-12 col-md-2" v-if="vagas_por_horario && !item.fl_ordem_chegada">
                                        <az-input 
                                            placeholder="1..."
                                            type="number" 
                                            label="Vagas por Horário"
                                            v-model="item.in_vagas_por_horario" 
                                            :validate="validate" />
                                    </div>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-3">
                                    <az-input 
                                        type="select" 
                                        label="Repetir a cada"
                                        :optionsList="[
                                            {id:1, search:'Semana'}, 
                                            {id:2, search:'15 dias'}, 
                                            {id:3, search:'3 Semanas'}, 
                                            {id:4, search:'4 Semanas'}
                                        ]"
                                        optionsData="id"
                                        required 
                                        v-model="item.in_intervalo_semanal" 
                                        :validate="validate" />
                                </div>

                                <div class="col col-12 col-md-5" v-if="!setup">
                                    <az-input 
                                        placeholder="Local"
                                        type="autocomplete" 
                                        optionsMode="aql"
                                        service="locals.index"
                                        :optionsSync="false"
                                        required 
                                        label="Local de Atendimento"
                                        v-model="item.local"
                                        :validate="validate"
                                        @input="checar_conflito_local(item)" />

                                    <div v-if="conflito_local && conflito_local.length">
                                        <a class="card-link" data-toggle="collapse" href="#collapseConflito" role="button">
                                            <i class="fa fa-exclamation-triangle text-warning mr-2" aria-hidden="true"></i>
                                            Conflito de Local
                                        </a>
                                        <div class="collapse" id="collapseConflito">
                                            <ul>
                                                <li v-for="(conflito, icx) in conflito_local" :key="icx">
                                                    {{ conflito.medico.search }}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div class="col col-12 col-md-2" v-if="!setup">
                                    <az-input
                                        label="Teleatendimento"
                                        type="checkbox"
                                        v-model="item.fl_tele_atd" />
                                </div>
                                <div class="col col-12 col-md-2" v-if="!setup">
                                    <az-input
                                        label="Pode Marcar em Feriado"
                                        type="checkbox"
                                        v-model="item.fl_pode_feriado" />
                                </div>
                            </div>

                            <div class="form-row" v-if="item.in_intervalo_semanal > 1">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        type="date"
                                        label="Início em"
                                        :validate="validate"
                                        v-model="item.dt_inicio_repeticao" />
                                </div>
                            </div>

                        </template>

                        <template v-if="!setup">

                            <template v-if="agenda_comp_medico && !setup && item.medico && item.medico.fl_agenda_compartilhada">

                                <div class="border-bottom text-primary mt-3">
                                    Profissional
                                </div>

                                <div class="form-row mt-3">
                                    <div class="col col-12 col-md-4">
                                        <az-input icon="fas fa-user-md fa-fw" 
                                            type="select" 
                                            optionsMode="aql"
                                            service="medicos.index"
                                            optionsName="medicos-cadastro-ativos-sac"
                                            :optionsParm="{ ativos: true, sem_agenda_compartilhada: true }"
                                            optionsData="id_pessoa"
                                            v-model="item.id_medico_comp"  />
                                    </div>
                                </div>

                            </template>

                            <div class="text-primary mt-3">
                                Procedimentos
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-9">
                                    <az-input 
                                        class="w-100"
                                        sizing="sm"
                                        placeholder="Pesquisar..."
                                        v-model="search_proc">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <template v-if="viewModeEdicao == 'T'">
                                                    <button type="button" class="btn btn-sm btn-outline-primary" @click="marcarTodos()">Todos</button>

                                                    <input class="mr-3" type="checkbox" v-model="comporMarcarTodos" @click="marcarTodos()" v-if="false">
                                                    <span v-if="false">Todos</span>
                                                </template>
                                                <template v-else>
                                                    <div class="input-group-text">
                                                        {{ lista_proced_agenda.length }}
                                                    </div>
                                                </template>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        type="button-group"
                                        :optionsList="[
                                            {id: 'T', search: 'Todos'},
                                            {id: 'S', search: 'Selecionados'},
                                        ]" 
                                        v-model="viewModeEdicao" />
                                </div>
                            </div>

                            <ul class="list-group mt-1">
                                <li class="list-group-item py-2" v-for="(mpu, im) in lista_proced_agenda" :key="im">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div>
                                            <input class="mr-3" type="checkbox" v-model="mpu.agenda_proc.fl_ativo" v-if="viewModeEdicao == 'T'">
                                            <a href="#" class="card-link small" @click.prevent="abrirProcedimento (mpu)">
                                                {{ mpu.procedimento.search }}
                                            </a>
                                            <span v-if="!mpu.id_medico_procedimento_unidade" data-toggle="tooltip" data-placement="top" title="Procedimento removido da habilitação do profissional ou inativado.">
                                                <i class="fa fa-exclamation-triangle text-warning" aria-hidden="true"></i>
                                            </span>
                                            <span v-if="mpu.agenda_proc.js_horarios" class="ml-2">
                                                <small class="text-muted" v-for="(horario, ihx) in mpu.agenda_proc.js_horarios" :key="ihx">
                                                    <span v-if="ihx"> / </span>
                                                    {{ horario.hora }}
                                                    <i class="fas fa-copyright mr-2" v-if="horario.tipo_consulta == 'C'"></i>
                                                    <i class="fas fa-registered mr-2" v-else-if="horario.tipo_consulta == 'R'"></i>
                                                </small>
                                            </span>
                                        </div>
                                        <div class="d-flex">
                                            <div style="width: 280px;" class="d-flex justify-content-end mr-2" v-if="mpu.agenda_proc.fl_ativo">
                                                <div v-if="mpu.procedimento.fl_simultaneo" style="width: 100px;" class="mr-3">
                                                    <div class="input-group input-group-sm mb-0">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text" id="basic-addon1">Qtd</span>
                                                        </div>
                                                        <input type="number" class="form-control" placeholder="1" min="0" max="99" v-model="mpu.agenda_proc.in_quantidade">
                                                    </div>
                                                </div>
                                                <div v-else-if="mpu.agenda_proc && mpu.agenda_proc.procedimento && mpu.agenda_proc.procedimento.id_classe_procedimento == 1" style="width: 100px;" class="mr-3">
                                                    <az-input
                                                        sizing="sm"
                                                        type="select"
                                                        placeholder="Tipo..."
                                                        :optionsList="[
                                                            {id: null, search: 'Qualquer'},
                                                            {id: 'I', search: 'Inicial'},
                                                            {id: 'S', search: 'Subsequente'},
                                                            {id: 'C', search: 'Inicial/Sub'},
                                                            {id: 'V', search: 'Inicial/Revisão'},
                                                            {id: 'R', search: 'Revisão'}
                                                        ]"
                                                        optionsData="id"
                                                        v-model="mpu.agenda_proc.ch_tipo_consulta" />
                                                </div>
                                                <div class="mr-3 small" style="width: 140px;">
                                                    <div class="input-group input-group-sm mb-0">
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text">
                                                                <input type="checkbox" v-model="mpu.agenda_proc.fl_agenda_online">
                                                            </div>
                                                        </div>
                                                        <label type="text" class="form-control small">
                                                            Agenda Online
                                                        </label>
                                                    </div>
                                                </div>
                                                <div v-if="1 == 0">
                                                    <input class="mr-2" type="checkbox" v-model="mpu.agenda_proc.fl_permitir_simultaneo">
                                                    <small>Simultâneo</small>
                                                </div>
                                            </div>

                                            <div style="width: 150px;">
                                                <az-input 
                                                    sizing="sm"
                                                    type="number"
                                                    placeholder="Tempo (min)"
                                                    :mb="false"
                                                    v-model="mpu.in_tempo_atendimento"
                                                    v-if="!item.fl_ordem_chegada && ( !mpu.procedimento || mpu.procedimento.id_especialidade != 2 )">
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append" v-if="mpu.agenda_proc.fl_ativo">
                                                            <button class="btn btn-outline-secondary" type="button" id="button-addon2" 
                                                                data-toggle="tooltip" data-placement="top" title="Definir horários fixos."
                                                                @click="mpu.agenda_proc.config = !mpu.agenda_proc.config">
                                                                <i class="far fa-clock"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>

                                                <div v-if="!item.fl_ordem_chegada && mpu.procedimento.id_classe_procedimento == 1 && ( !mpu.procedimento || mpu.procedimento.id_especialidade != 2 )">
                                                    <az-input 
                                                        sizing="sm"
                                                        type="number"
                                                        placeholder="Tempo (min)"
                                                        :mb="false"
                                                        v-model="mpu.in_tempo_atendimento_sub">
                                                        <template v-slot:button-pre>
                                                            <div class="input-group-prepend">
                                                                <div class="input-group-text" title="Consulta Subsequente.">Sub</div>
                                                            </div>
                                                        </template>
                                                    </az-input>

                                                    <az-input 
                                                        sizing="sm"
                                                        type="number"
                                                        placeholder="Tempo (min)"
                                                        :mb="false"
                                                        v-model="mpu.in_tempo_atendimento_rev">
                                                        <template v-slot:button-pre>
                                                            <div class="input-group-prepend">
                                                                <div class="input-group-text" title="Consulta Revisão.">Rev</div>
                                                            </div>
                                                        </template>
                                                    </az-input>
                                                </div>

                                                <az-input 
                                                    sizing="sm"
                                                    type="number"
                                                    placeholder="1..."
                                                    :mb="false"
                                                    v-model="mpu.agenda_proc.in_slots"
                                                    v-else-if="item.id_agenda > 0 && item.fl_ordem_chegada && mpu.agenda_proc">
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append">
                                                            <span class="input-group-text" id="basic-addon1">
                                                                {{ mpu.agenda_proc.in_slots > 1 ? 'Slots' : 'Slot' }}
                                                            </span>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card mt-1 mb-1" v-if="mpu.agenda_proc.config && !item.fl_ordem_chegada">
                                        <div class="card-body">
                                            <div class="form-row">
                                                <template v-if="mpu.agenda_proc.js_horarios">
                                                    <div class="col col-12 col-md-3" v-for="(horario, ihx) in mpu.agenda_proc.js_horarios" :key="ihx">
                                                        <az-input 
                                                            sizing="sm"
                                                            type="time"
                                                            required
                                                            :validate="validate"
                                                            v-model="horario.hora">
                                                            <template v-slot:button-pre>
                                                                <div class="input-group-prepend">
                                                                    <button class="btn btn-outline-danger" type="button" id="button-addon2" 
                                                                        @click="mpu.agenda_proc.js_horarios.splice(ihx, 1)">
                                                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                                                    </button>
                                                                </div>
                                                            </template>
                                                            <template v-slot:buttonposb>
                                                                <div class="input-group-append" v-if="mpu.procedimento.id_classe_procedimento == 1">
                                                                    <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown">
                                                                        <i class="fas fa-circle" v-if="!horario.tipo_consulta"></i>
                                                                        <i class="fas fa-copyright" v-if="horario.tipo_consulta == 'C'"></i>
                                                                        <i class="fas fa-registered" v-if="horario.tipo_consulta == 'R'"></i>
                                                                    </button>
                                                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                        <a class="dropdown-item" href="#" @click.prevent="horario.tipo_consulta = ''">
                                                                            <i class="fas fa-circle mr-2"></i>
                                                                            Qualquer
                                                                        </a>
                                                                        <a class="dropdown-item" href="#" @click.prevent="horario.tipo_consulta = 'C'">
                                                                            <i class="fas fa-copyright mr-2"></i>
                                                                            Inicial/Subsequente
                                                                        </a>
                                                                        <a class="dropdown-item" href="#" @click.prevent="horario.tipo_consulta = 'R'">
                                                                            <i class="fas fa-registered mr-2"></i>
                                                                            Revisão
                                                                        </a>
                                                                        <template v-if="pode_bloquear_horario">
                                                                            <div class="dropdown-divider"></div>
                                                                            <a class="dropdown-item" href="#" @click.prevent="bloquear_horario(horario)">
                                                                                <i class="fa fa-ban mr-2" aria-hidden="true"></i>
                                                                                Bloquear Horário
                                                                            </a> 
                                                                        </template>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </az-input>

                                                        <template v-if="horario.bloqs">
                                                            <div v-for="(hbl, ibx) in horario.bloqs" :key="ibx">
                                                                <az-input 
                                                                    sizing="sm"
                                                                    type="time"
                                                                    required
                                                                    :validate="validate"
                                                                    v-if="!hbl.horas"
                                                                    v-model="hbl.hora">
                                                                    <template v-slot:button-pre>
                                                                        <div class="input-group-prepend">
                                                                            <span class="input-group-text" id="basic-addon1">
                                                                                <i class="fa fa-ban" aria-hidden="true"></i>
                                                                            </span>
                                                                            <button class="btn btn-outline-danger" type="button" id="button-addon2" 
                                                                                @click="del_hor_bloq(horario, ibx)">
                                                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                                                            </button>
                                                                        </div>
                                                                    </template>
                                                                </az-input>
                                                            
                                                                <template v-else>
                                                                    <div v-for="(horabl, ihx) in hbl.horas" :key="ihx">
                                                                        <az-input 
                                                                            sizing="sm"
                                                                            type="time"
                                                                            required
                                                                            :validate="validate"
                                                                            v-model="horabl.hora">
                                                                            <template v-slot:button-pre>
                                                                                <div class="input-group-prepend">
                                                                                    <span class="input-group-text" id="basic-addon1">
                                                                                        <i class="fa fa-ban" aria-hidden="true"></i>
                                                                                    </span>
                                                                                    <span class="input-group-text" id="basic-addon1" v-if="ihx">
                                                                                        Ou
                                                                                    </span>
                                                                                    <span class="input-group-text" id="basic-addon1" v-else-if="!ihx && ibx">
                                                                                        E
                                                                                    </span>
                                                                                </div>
                                                                            </template>

                                                                            <template v-slot:buttonposb>
                                                                                <div class="input-group-append">
                                                                                    <button class="btn btn-outline-secondary px-1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                                        <i class="fas fa-ellipsis-v"></i>
                                                                                    </button>
                                                                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                                        <a class="dropdown-item" href="#" @click.prevent="add_hor_bloq_ou(hbl.horas)">
                                                                                            <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                                                                                            Ou...
                                                                                        </a>
                                                                                        <a class="dropdown-item" href="#" @click.prevent="del_hor_bloq_item(hbl.horas, ihx, horario.bloqs, ibx)">
                                                                                            <i class="fa fa-minus mr-2" aria-hidden="true"></i>
                                                                                            Remover
                                                                                        </a>
                                                                                    </div>
                                                                                </div>
                                                                            </template>
                                                                        </az-input>
                                                                    </div>
                                                                </template>
                                                                            
                                                            </div>

                                                            <button type="button" class="btn btn-outline-danger btn-sm mb-3" @click="add_hor_bloq(horario)">
                                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                                            </button>
                                                        </template>
                                                    </div>
                                                </template>
                                                <div class="col col-12 col-md-3">
                                                    <button type="button" class="btn btn-sm btn-outline-primary" @click="incluir_horario_fixo(mpu)">
                                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>

                        </template>

                        <template v-if="!setup && ( item.acao_proced == 'C' || !item.acao_proced )">

                            <div class="border-bottom text-primary mt-3">
                                Operadoras
                            </div>

                            <div class="form-row mt-3">

                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        icon="fa fa-filter fa-fw"
                                        type="select"
                                        placeholder="Selecione..."
                                        :optionsList="[
                                            { id: 'T', search: 'Todas' },
                                            { id: 'A', search: 'Apenas' },
                                            { id: 'E', search: 'Exceto' },
                                        ]"
                                        required
                                        :validate="validate"
                                        optionsData="id"
                                        v-model="item.ch_filtro_operadora" />
                                </div>

                                <template v-if="item && ( item.ch_filtro_operadora == 'A' || item.ch_filtro_operadora == 'E' )">
                                    
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            sizing="sm"
                                            name="operadora-pacote"
                                            icon="fas fa-plus"
                                            type="select"
                                            optionsMode="aql"
                                            :optionsParm2="{ fatura: true }"
                                            service="operadoras.index"
                                            v-model="agendaNovaOperadora"
                                            @input="adicionarOperadora ()" />
                                    </div>

                                    <div class="col col-12 col-md-4" v-for="(po, ipo) in item.operadoras" :key="ipo">
                                        <az-input 
                                            sizing="sm"
                                            type="checkbox-group"
                                            :label="po.search"
                                            v-model="po.selecionado" />
                                    </div>

                                </template>

                            </div>

                            <!-- Filtros para Agenda Online-->
                            <filtro-model class="my-3" :title="'Filtros para Agenda' + ( filtro_agenda_geral ? '' : ' Online' )" v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />

                            <br><br><br><br><br>

                        </template>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="agenda" :id="item.id_agenda" v-if="item.id_agenda && !setup" />
                        <az-submit color="danger" @click="remover ()" v-if="item.id_agenda">Remover</az-submit>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>

                        <az-submit @click="atualizar ()" color="danger" v-if="item.acao_proced == 'R'">Remover</az-submit>
                        <az-submit @click="atualizar ()" color="primary" v-else-if="item.acao_proced == 'I'">Incluir</az-submit>
                        <az-submit @click="atualizar ()" v-else>Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="foraPeriodoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Marcações fora do horário</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body" v-if="fora_periodo">
                        <div class="lead">
                            {{ fora_periodo.length }} {{ fora_periodo.length == 1 ? 'marcação presente' : 'marcações presentes' }} 
                            no horário reduzido.
                        </div>

                        <div id="impressao-fora-periodo">
                            <table class="table mt-3">
                                <thead>
                                    <tr>
                                        <th>Data/Hora</th>
                                        <th>Paciente</th>
                                        <th>Procedimento</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(mrc, imx) in fora_periodo" :key="imx">
                                        <td>{{ $util.getFormatDate(mrc.dt_inicio) }} {{ mrc.dt_inicio.substr(11,5) }}</td>
                                        <td>{{ mrc.nome_paciente }}</td>
                                        <td>{{ mrc.procedimento.search }}</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-success" @click="imprimir_fora_periodo()">Imprimir</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Editar Encerramento -->
        <div class="modal fade" id="edicaoEncerramentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Novo Período</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p class="alert alert-warning">
                            Essa opção irá editar a data de encerramento de todas as agendas listadas.<br>
                            Não impacta agendas marcadas como eventuais, ou que o prestador já tenha outra agenda (não eventual) com início posterior a essa.
                        </p>
                        <az-input
                            type="date"
                            :validate="validate"
                            required
                            v-model="encerramento" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_edicao_encerramento()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="unidadeLimiteModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="edicao_unidade">
                    <div class="modal-header">
                        <h5 class="modal-title">Limite de Abertura de Agenda para Unidade</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <h4>{{ edicao_unidade.st_nome }}</h4>
                        <div class="alert alert-info">
                            Prazo limite de abertura da agenda. Nenhuma agenda será disponibilizada após a data informada.
                        </div>
                        <az-input
                            type="date"
                            v-model="edicao_unidade.dt_limite_agenda_aberta" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_unidade_limite()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Agenda Grupo Data -->
        <div class="modal fade" id="agendaGrupoDataModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="datas">
                    <div class="modal-header">
                        <h5 class="modal-title">Datas</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col">
                                <az-periodo v-model="datas.filtros" :sync="true" @sync="load_datas()" />
                            </div>
                        </div>

                        <az-empty-state 
                            class="mt-3" 
                            msg="Nenhuma data informada." 
                            icon="fa-solid fa-calendar-check" 
                            v-if="!datas.lista || !datas.lista.filter(item => !item.excluido).length" 
                            action="Incluir" 
                            :method="incluir_data" />

                        <template v-else>
                            <template v-for="(agd, iax) in datas.lista">
                                <div class="form-row" :key="iax" v-show="!agd.excluido" v-if="true">
                                    <div class="col col-12 col-md-4">
                                        <az-input 
                                            type="date"
                                            required
                                            :validate="validate"
                                            v-model="agd.dt_data">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="agd.excluido = true">
                                                        <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-4" v-if="agd.dt_data">
                                        <span class="small text-muted">
                                            {{ $util.getFormatDate(agd.dt_data, 'dddd') }}
                                        </span>
                                    </div>
                                </div>
                            </template>

                            <button type="button" class="btn btn-outline-primary" @click="incluir_data()">
                                <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                            </button>

                            <span class="badge badge-secondary ml-2">
                                {{ datas.lista.filter(item => !item.excluido).length }}
                            </span>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_datas()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Editar Agendas -->
        <div class="modal fade" id="edicaoAgendasModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Editar Agendas</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="edicao_agendas">

                        <div class="form-row mb-3">
                            <div class="col col-12 d-flex flex-column">
                                <az-input 
                                    type="button-group"
                                    :optionsList="[
                                        { id: 'M', search: 'Hora Marcada' }, 
                                        { id: 'C', search: 'Ordem de Chegada' }, 
                                    ]"
                                    v-model="tipo_agenda" />
                            </div>
                        </div>

                        <div class="form-row mb-3">
                            <div class="col col-12 col-md-3">
                                <az-input 
                                    type="number" 
                                    label="Tempo de Atendimento"
                                    v-model="edicao_agendas.in_tempo_atendimento" 
                                    placeholder="Manter Atual..."
                                    :validate="validate" 
                                    v-if="tipo_agenda == 'M'" />

                                <az-input 
                                    type="number" 
                                    label="Quantidade de Pacientes"
                                    v-model="edicao_agendas.in_tempo_atendimento" 
                                    placeholder="Manter Atual..."
                                    :validate="validate" 
                                    v-else />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input 
                                    type="number" 
                                    label="Extras"
                                    v-model="edicao_agendas.in_vagas_extras" 
                                    placeholder="Manter Atual..."
                                    :validate="validate" 
                                    v-if="tipo_agenda == 'M'" />
                            </div>
                            <div class="col col-12 col-md-3" v-if="vagas_por_horario && tipo_agenda == 'M'">
                                <az-input 
                                    placeholder="Manter Atual..."
                                    type="number" 
                                    label="Vagas por Horário"
                                    v-model="edicao_agendas.in_vagas_por_horario" 
                                    :validate="validate" />
                            </div>
                        </div>

                        <table class="table table-sm">
                            <thead>
                                <tr>
                                    <th>
                                        <button type="button" class="btn btn-outline-primary btn-sm" @click="selecao_todas(edicao_agendas.info.agenda, 'fl_ativo')">Todas</button>
                                    </th>
                                    <th>Dia</th>
                                    <th>Horário</th>
                                    <th>Título</th>
                                    <th>Local</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, idx) in edicao_agendas.info.agenda" :key="idx">
                                    <td>
                                        <input type="checkbox"
                                            :disabled="!( ( tipo_agenda == 'M' && !item.fl_ordem_chegada ) || ( tipo_agenda == 'C' && item.fl_ordem_chegada ) )"
                                            v-model="item.fl_ativo" />
                                    </td>
                                    <td>{{ texto_do_dia(item.in_dia_semana) }}</td>
                                    <td>{{ item.search }}</td>
                                    <td>{{ item.st_titulo }}</td>
                                    <td>{{ item.local.search }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar_agendas()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AgendaDia from '../shared/AgendaDia.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import FiltroModel from '../shared/FiltroModel.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            procedimentos: null, 
            validate: false,
            medico: "",
            search: "", 
            nova: null, 
            comporMarcarTodos: false,
            unidade_operacao: "",
            viewMode: 'A',
            medicoUnidades: [],
            fora_periodo: [], 
            referencia: "", 
            encerramento: "", 
            timeout: null, 
            conflito_local: null, 
            grupo: null, 
            abrindo_edicao: false, 
            viewModeEdicao: "", 
            montando: true, 
            unidades: null, 
            edicao_unidade: null,
            agendaNovaOperadora: "", 
            pode_bloquear_horario: false, 
            vagas_por_horario: false, 
            agenda_comp_medico: false, 
            datas: { 
                agenda_grupo: null, 
                filtros: { 
                    periodo: "m",
                },
                lista: [],
            },
            edicao_agendas: null, 
            tipo_agenda: "M", 
            filtro_agenda_geral: false, 
            search_proc: "", 
        }
    },

    props: ['id_medico', 'setup'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AgendaDia, 
        AzSubmit,
        AzAuditLogButton,
        AzPeriodo, 
        FiltroModel, 
    },

    watch: { 
        especialidade: function () { 
            this.load ();
        }
    },
    
    computed: { 
        lista_operadoras_selecionadas: function () { 
            if ( !this.item || !this.item.operadoras )
                return [];

            return this.item.operadoras.filter(oper => oper.selecionado);
        },

        lista_proced_agenda: function () { 
            if ( !this.procedimentos || !this.procedimentos.medico_procedimento_unidades )
                return [];

            let reg = this.$util.getregex(this.search_proc);

            return this.procedimentos.medico_procedimento_unidades.filter(item => this.viewModeEdicao == 'T' || item.agenda_proc.fl_ativo)
                .filter(item => !this.search_proc || reg.test(item.procedimento.search));
        },

        lista_filtrada: function () { 

            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            if ( !this.dados )
                return [];

            let lista = ( this.viewMode == 'A' ? this.dados.filter(item => item.fl_ativo && item.dt_vigencia_termino >= this.$util.hoje ()) : this.dados);

            lista = lista.filter (item => ( this.viewMode == 'T' || item.fl_ativo ) 
                && ( !this.search || reg.test(JSON.stringify(item)) ) );

            return lista;

        },

        lista: function () { 
            return _.groupBy(this.lista_filtrada, item => item.medico.search);
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                        
                //{id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                //{id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                //{id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                //{id:'App\\azure\\unidadeOperacao', search:'Unidade', service:'unidade_operacaos.index'}
            ];

            return opcoes;
        }
    },

    methods: { 
        selecao_todas(lista, campo) { 
            let selec = lista.find(item => !_.get(item, campo)) ? true : false;
            lista.forEach(item => item[campo] = selec);
        },

        editar_agendas (dado) { 
            this.tipo_agenda = _.get(dado, 'agenda.0.fl_ordem_chegada') ? 'C' : 'M'; 
            
            this.edicao_agendas = { 
                in_tempo_atendimento: "", 
                in_vagas_por_horario: "", 
                in_vagas_extras: "", 
                info: _.cloneDeep(dado)
            };

            this.edicao_agendas.info.agenda = _.orderBy(
                this.edicao_agendas.info.agenda.filter(item => item.fl_ativo), 
                agenda => agenda.in_dia_semana + agenda.search + agenda.st_titulo
            );

            $('#edicaoAgendasModal').modal('show');
        },

        atualizar_agendas() { 
            this.$util.atualizar(this, { 
                service: 'agendas',
                func: 'editar_agendas', 
                dados: { 
                    id_agenda_grupo: this.edicao_agendas.info.id_agenda_grupo, 
                    in_tempo_atendimento: this.edicao_agendas.in_tempo_atendimento, 
                    in_vagas_por_horario: this.edicao_agendas.in_vagas_por_horario, 
                    in_vagas_extras: this.edicao_agendas.in_vagas_extras, 
                    ids_agenda: this.edicao_agendas.info.agenda.filter(item => item.fl_ativo)   
                        .filter(item => ( !item.fl_ordem_chegada && this.tipo_agenda == 'M' )
                            || ( item.fl_ordem_chegada && this.tipo_agenda == 'C' ))
                        .map(item => item.id_agenda),
                },
                toast: true, 
                modal: 'edicaoAgendasModal',
            });
        },

        salvar_datas () { 

            this.$util.atualizar(this, { 
                service: 'agenda_grupo_datas',
                func: 'salvar_grupo_datas',
                dados: { 
                    ...this.datas.filtros, 
                    lista: this.datas.lista, 
                },
                modal: 'agendaGrupoDataModal',
                reload: true, 
            });

        },

        incluir_data () { 
            this.datas.lista.push({
                id_agenda_grupo: this.datas.agenda_grupo.id_agenda_grupo,
                id_agenda_grupo_data: null, 
                dt_data: "", 
                excluido: false, 
            });
        },

        load_datas () { 
            this.$util.load(this, { 
                service: 'agenda_grupo_datas',
                func: 'index',
                parms: { 
                    ...this.datas.filtros, 
                    id_agenda_grupo: this.datas.agenda_grupo.id_agenda_grupo, 
                },
                loadTo: res => { 
                    this.datas.lista = res;
                }
            });
        },

        informar_datas (dado) { 
            this.datas.agenda_grupo = _.cloneDeep(dado); 
            this.datas.lista = [];

            this.load_datas();

            $('#agendaGrupoDataModal').modal('show');
        },

        del_hor_bloq (horario, idx) { 
            horario.bloqs.splice(idx, 1);

            this.$forceUpdate();
        },

        add_hor_bloq (horario) { 
            horario.bloqs.push({
                horas: [
                    { 
                        hora: "", 
                    }
                ], 
            });

            this.$forceUpdate();
        },

        del_hor_bloq_item (lista, idx, listasuper = null, idxs = null) { 
            lista.splice(idx, 1);

            if ( !lista.length && listasuper ) { 
                listasuper.splice(idxs, 1);
            }

            this.$forceUpdate();
        },

        add_hor_bloq_ou (horas) { 
            console.log('Horas', horas);

            horas.push({
                hora: "", 
            });

            this.$forceUpdate();
        },

        bloquear_horario (horario) { 
            if ( horario.bloqs ) { 
                horario.bloqs = null;
            } else { 
                horario.bloqs = [];
            }

            this.$forceUpdate();
        },

        adicionarOperadora () { 

            if ( this.agendaNovaOperadora ) { 
                
                this.item.operadoras.push({
                    id_agenda: this.item.id_agenda,
                    id_operadora: this.agendaNovaOperadora.id_operadora,
                    search: this.agendaNovaOperadora.search,
                    selecionado: true, 
                });

                this.$nextTick (() => { 
                    this.agendaNovaOperadora =  "";
                });

            }

        },
        
        salvar_unidade_limite () { 
            if ( !confirm ('Confirma a edição da data limite?') ) 
                return;

            this.$util.atualizar(this, { 
                service: 'unidade_operacaos',
                func: 'store',
                dados: { 
                    ...this.edicao_unidade,
                    cadastro_agenda: true 
                },
                toast: true, 
                reload: true, 
                modal: 'unidadeLimiteModal',
            });
        },

        abrir_limite_agenda (unid) { 
            this.edicao_unidade = _.cloneDeep(unid);

            $('#unidadeLimiteModal').modal('show');
        },

        dias_com_agenda (dias) { 
            if ( !this.grupo )
                return dias;

            return dias.filter(dia => this.grupo.agenda.findIndex(agenda => agenda.in_dia_semana == dia.dia) >= 0);
        },
        incluir_proced(grupo, inclusao = true) { 
            this.validate = false;
            this.grupo = grupo;

            let item = {
                id_agenda_grupo: grupo.id_agenda_grupo, 
                id_medico: grupo.id_medico, 
                id_local: 1, 
                id_agenda: null, 
                in_tempo_atendimento: 30, 
                fl_ordem_chegada: false, 
                in_vagas_extras: 0, 
                fl_ativo: true,
                fl_agenda_online: false, 
                in_intervalo_semanal: 1,
                dias: [
                    { nome: 'Seg', dia: 1, selecionado: false },
                    { nome: 'Ter', dia: 2, selecionado: false },
                    { nome: 'Qua', dia: 3, selecionado: false },
                    { nome: 'Qui', dia: 4, selecionado: false },
                    { nome: 'Sex', dia: 5, selecionado: false },
                    { nome: 'Sab', dia: 6, selecionado: false },
                    { nome: 'Dom', dia: 0, selecionado: false },
                ],
                agenda_procedimentos: [], 
                acao_proced: inclusao ? 'I' : 'R',
            };

            this.editar (item);
        },

        texto_do_dia(dia) { 
            switch (dia) {
                case 0: return 'Domingo';
                case 1: return 'Segunda-feira';
                case 2: return 'Terça-feira';
                case 3: return 'Quarta-feira';
                case 4: return 'Quinta-feira';
                case 5: return 'Sexta-feira';
                case 6: return 'Sábado';
            }
        },

        checar_conflito_local(item) { 
            this.conflito_local = null;
            
            if ( !item || !item.id_agenda || !item.local || !item.hora_inicio || !item.hora_termino ) 
                return;

            if ( this.abrindo_edicao ) { 
                return;
            }
        
            this.$util.loadItem(this, { 
                service: 'agendas',
                func: 'conflito_local', 
                parms: item, 
            })
            .then(res => { 
                this.conflito_local = res;
            });
        },

        incluir_horario_fixo(mpu) { 
            if ( !mpu.agenda_proc.js_horarios ) 
                mpu.agenda_proc.js_horarios = [];

            mpu.agenda_proc.js_horarios.push({ hora: "", tipo_consulta: "" });
        },

        salvar_edicao_encerramento() { 
            this.$util.atualizar(this, { 
                service: 'agendas',
                func: 'salvar_encerramento',
                dados: { 
                    encerramento: this.encerramento,
                    lista: _.map(this.lista_filtrada, item => _.pick(item, ['id_agenda_grupo'])),
                },
                toast: true, 
                modal: 'edicaoEncerramentoModal',
                reload: true, 
            });
        },

        editar_encerramento() { 
            if ( !this.referencia ) {

                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Selecione a data para edição do encerramento de agendas válidas na data selecionada.",
                    life: 3000
                });

                return;

            }

            this.encerramento = "";
            this.validate = false;

            $('#edicaoEncerramentoModal').modal('show');
        },

        remover () { 
            if ( !confirm("Confirma remover essa agenda?") )
                return;

            this.$util.toggle(this, { 
                service: 'cadastro_agendas',
                dados: { 
                    id_agenda: this.item.id_agenda,
                    fl_ativo: false,
                },
                callback: () => { 
                    $('#agendaEdicaoModal').modal('hide');
                    this.load();
                } 
            });
        },
        marcarTodos () { 
            this.$nextTick(() => { 
                let marcado = this.procedimentos.medico_procedimento_unidades.find(item => { 
                        return item.agenda_proc.fl_ativo;
                    })
                    ? true
                    : false;

                console.log('marcado', marcado);

                this.procedimentos.medico_procedimento_unidades.forEach(item => { 
                    item.agenda_proc.fl_ativo = !marcado;
                });

                this.$forceUpdate();
            });
        },

        abrirProcedimento (proc) { 
            this.$util.abrirProcedimento(proc.procedimento);
        },

        incluirAgendaGrupo () { 
            if ( !this.medico ) { 

                this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Selecione o médico.",
                        life: 3000
                    });

            } else { 

                this.validate = false;

                this.nova = {  
                    dt_vigencia_inicio: "",
                    dt_vigencia_termino: "", 
                    id_medico: this.medico.id_pessoa, 
                    fl_ativo: true,
                    fl_eventual: false,
                    st_observacoes: "", 
                    clone: false, 
                    base: "", 
                };

                $('#novaAgendaGrupoModal').modal('show');

            }
        },
        abrirMedico () { 
            if ( !this.medico ) { 

                this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Selecione o médico.",
                        life: 3000
                    });
                
            } else { 

                this.$util.abrirMedico(this.medico);

            }
        },
        agendas (dado, dia) { 
            if ( !dado.agenda )
                return [];

            return dado.agenda.filter(i => { 
                return i.in_dia_semana == dia;
            });
        },
        comporAgenda (grupo) { 
            this.validate = false;
            this.viewModeEdicao = 'T';
            this.grupo = grupo;

            let item = {
                id_agenda_grupo: grupo.id_agenda_grupo, 
                id_medico: grupo.id_medico, 
                id_local: 1, 
                id_agenda: null, 
                in_tempo_atendimento: 30, 
                fl_ordem_chegada: false, 
                in_vagas_extras: 0, 
                fl_ativo: true,
                fl_agenda_online: false, 
                in_intervalo_semanal: 1,
                ch_filtro_operadora: 'T', 
                dias: [
                    { nome: 'Seg', dia: 1, selecionado: false },
                    { nome: 'Ter', dia: 2, selecionado: false },
                    { nome: 'Qua', dia: 3, selecionado: false },
                    { nome: 'Qui', dia: 4, selecionado: false },
                    { nome: 'Sex', dia: 5, selecionado: false },
                    { nome: 'Sab', dia: 6, selecionado: false },
                    { nome: 'Dom', dia: 0, selecionado: false },
                ],
                agenda_procedimentos: [], 
                acao_proced: 'C', 
                medico: grupo.medico ? grupo.medico : null, 
            };

            if ( grupo.eventual_dias ) { 
                item.dias = item.dias.filter(dia => grupo.eventual_dias.filter(ed => ed === dia.dia).length);
            }

            this.editar (item);
        },
        load_by_referencia () { 

            if ( this.montando )
                return;

            if (this.timeout) { 
                clearTimeout(this.timeout); 
                this.timeout = null;
            }

            this.timeout = setTimeout(() => {
                this.load();
            }, 300);

        },
        load (refresh = false) { 
            if ( this.montando )
                return;

            this.$store.commit('setContexto', 
                { 
                    medico: this.medico ? this.medico.id_pessoa : null,
                });

            let id_medico = ( this.medico && this.medico.id_pessoa ) ? this.medico.id_pessoa : null;
            let filtro = id_medico ? { id_medico: id_medico } : {};

            this.$store.commit('loading', true);

            if ( !refresh ) {
                this.dados = null;
                this.procedimentos = null;
                this.medicoUnidades = null; 
            }

            this.item = null;
            this.nova = null; 
            
            
            let query = { q: [
                { 
                    name: 'agenda_grupos.index',
                    id: 'lista',
                    parms: { 
                        where: { 
                            ...filtro,
                        },
                        id_unidade_operacao: this.unidade_operacao,
                        referencia: this.referencia,
                        id_medico: id_medico,
                        cadastro: true, 
                        lista: true, 
                    }
                },
                { 
                    name: 'medico_unidades.index',
                    id: 'procedimentos',
                    parms: { 
                        cadastro_agenda: true, 
                        where: { 
                            ...filtro,
                        },
                    }
                },
                { 
                    name: 'unidade_operacaos.index',
                    id: 'unidades',
                    parms: { 
                        cadastro_agenda: true, 
                        where: this.unidade_operacao ? { 
                            id_unidade_operacao: this.unidade_operacao, 
                        } : {}, 
                    }
                },
                {
                    name: 'configuracoes.index',
                    id: 'configmotivo',
                    parms: {
                        where: {
                            st_slug: 'motivo-bloqueio-horario',
                            fl_ativo: '1',
                        }
                    } 
                },
                {
                    name: 'configuracoes.index',
                    id: 'configvagasporhorario',
                    parms: {
                        where: {
                            st_slug: 'vagas-por-horario',
                            fl_ativo: '1',
                        }
                    } 
                },
                {
                    name: 'configuracoes.index',
                    id: 'configfiltroagendageral',
                    parms: {
                        where: {
                            st_slug: 'agenda-filtro-geral',
                            fl_ativo: '1',
                        }
                    } 
                },
                {
                    name: 'configuracoes.index',
                    id: 'configmedicocomp',
                    parms: {
                        where: {
                            st_slug: 'agenda-compartilhada-medico',
                            fl_ativo: '1',
                        }
                    } 
                },
            ]};

            this.axios.post('/aql?a=agenda_grupos.index', query)
                .then(res => { 
                    if ( res.data.lista.status == 200 ) { 
                        this.dados = _.orderBy(res.data.lista.data, (item) => item.medico.search);
                    }

                    if ( res.data.procedimentos && res.data.procedimentos.status == 200 ) { 
                        if ( res.data.procedimentos.data.length ) { 
                            this.medicoUnidades = res.data.procedimentos.data

                            if ( id_medico )
                                this.procedimentos = res.data.procedimentos.data[0];
                        }
                    }

                    if ( res.data.unidades && res.data.unidades.status == 200 ) { 
                        this.unidades = res.data.unidades.data;
                    }

                    if ( res.data.configmotivo && res.data.configmotivo.status == 200 ) { 
                        this.pode_bloquear_horario = ( _.get(res.data.configmotivo.data, '0.st_valor') > 0 );
                    }

                    if ( res.data.configvagasporhorario && res.data.configvagasporhorario.status == 200 ) { 
                        this.vagas_por_horario = _.get(res.data.configvagasporhorario.data, '0.st_valor') ? true : false;
                    }

                    if ( res.data.configmedicocomp && res.data.configmedicocomp.status == 200 ) { 
                        this.agenda_comp_medico = _.get(res.data.configmedicocomp.data, '0.st_valor') ? true : false;
                    }

                    if ( res.data.configfiltroagendageral && res.data.configfiltroagendageral.status == 200 ) { 
                        this.filtro_agenda_geral = _.get(res.data.configfiltroagendageral.data, '0.st_valor') ? true : false;
                    }
                    
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

        },
        editar (item) { 
            if ( item.id_agenda ) { 
                this.viewModeEdicao = 'S';
            }

            this.abrindo_edicao = true;

            this.conflito_local = null;
            this.validate = false;
            this.item = null;

            if ( !this.setup && ( !this.medico || !this.medico.id_pessoa ) ) { 
                this.procedimentos = this.medicoUnidades.find(mu => mu.id_medico == item.id_medico);
            }

            if ( item.id_agenda && !item.agenda_procedimentos ) { 

                this.$util.load(this, { 
                    service: 'agendas',
                    func: 'show',
                    parms: { 
                        id: item.id_agenda, 
                        id_medico: item.id_medico, 
                        cadastro: true, 
                    },
                    loadTo: res => { 

                        if ( res.agenda_procedimentos ) { 
                            this.editar(res);
                        }

                    }
                });

                return;

            }

            this.$nextTick (() => { 

                let procs;
                let agp_keys = _.mapKeys(
                    _.cloneDeep(item.agenda_procedimentos),
                    ag => ag.id_procedimento
                );

                if ( this.setup ) { 

                    this.procedimentos = { 
                        medico_procedimento_unidades: [],
                    };

                } 
                
                procs = this.procedimentos.medico_procedimento_unidades.map(proc => { 
                    proc.agenda_proc = _.get(agp_keys, proc.id_procedimento);
                    
                    /*
                    item.agenda_procedimentos.find(ap => { 
                        return ap.id_procedimento == proc.id_procedimento;
                    });
                    */

                    if ( !proc.agenda_proc ) {
                        proc.agenda_proc = { 
                            id_agenda_procedimento: null, 
                            id_procedimento: proc.id_procedimento,
                            fl_ativo: false, 
                            config: false, 
                            js_horarios: [], 
                            in_quantidade: 1, 
                            fl_agenda_online: false, 
                            fl_permitir_simultaneo: false, 
                        };
                    }

                    return proc;
                });

                procs = procs.sort((a, b) => { 
                        return a.procedimento.search > b.procedimento.search ? 1 : -1;
                    });

                this.procedimentos.medico_procedimento_unidades = _.cloneDeep(procs);

                if ( !this.setup ) { 

                    let outros = item.agenda_procedimentos.filter(agp => !this.procedimentos.medico_procedimento_unidades.find(proc => proc.agenda_proc.id_procedimento == agp.id_procedimento));

                    outros.forEach(outro => { 
                        this.procedimentos.medico_procedimento_unidades.push({ 
                            agenda_proc: outro, 
                            procedimento: outro.procedimento,
                            id_procedimento: outro.id_procedimento, 
                            id_medico_procedimento_unidade: null, 
                        });
                    });

                }

                if ( item.ch_filtro_operadora == 'T' && item.operadoras && item.operadoras.length ) { 
                    item.ch_filtro_operadora = 'A';
                }

                this.item = _.cloneDeep (item);

                $('#agendaEdicaoModal').modal('show');

                this.$nextTick(() => { 
                    this.abrindo_edicao = false;
                    this.checar_conflito_local(this.item);
                });

            });
        },
        editarAgendaGrupo (agendaGrupo, clone = false) { 

            let novo = _.cloneDeep(agendaGrupo);

            if ( clone ) { 
                novo.clonar_para_outro = false;
                novo.id_medico_destino_clone = "";
            }

            novo.clone = clone;
            novo.base = "";

            //

            this.nova = novo;

            if ( clone ) { 
                this.nova.base = this.nova.dt_vigencia_termino.substr(0,10);
                this.nova.dt_vigencia_inicio = "";
                this.nova.dt_vigencia_termino = "";
                this.nova.fl_eventual = false;
                this.nova.fl_listar_datas = false;
                this.nova.id_agenda_grupo_base = this.nova.id_agenda_grupo;
                this.nova.id_agenda_grupo = null;   
            } else {
                this.nova.dt_vigencia_inicio = this.nova.dt_vigencia_inicio.substr(0,10);
                this.nova.dt_vigencia_termino = this.nova.dt_vigencia_termino.substr(0,10);
            }

            this.validate = false;

            $('#novaAgendaGrupoModal').modal('show');

        },
        criarAgendaGrupo () { 

            this.$util.atualizar (this, { 
                service: 'agenda_grupos',
                dados: { 
                    ...this.nova,
                }, 
                reload: true, 
                modal: 'novaAgendaGrupoModal',
            });

        },
        atualizar () { 

            if ( this.item.id_agenda ) { 

                this.fora_periodo = [];

                this.$store.commit('loading', true);

                // Verificação de exames fora do horário alterado.

                this.$util.loadItem(this, { 
                    service: 'agendas',
                    func: 'verificar_horarios_agenda',
                    parms: { 
                        ...this.item,
                    }
                })
                .then(res => { 

                    this.fora_periodo = res;

                    this.$util.atualizar (this, { 
                        service: 'cadastro_agendas',
                        dados: { 
                            ...this.item,
                            procedimentos: this.procedimentos,  
                            setup: this.setup, 
                        }, 
                        reload: false, 
                        modal: 'agendaEdicaoModal',
                        callback: () => { 
                            this.exibir_fora_periodo();
                            this.load(true);
                            this.$emit('refresh');
                        }
                    });

                })
                .finally(() => { 
                    if ( !this.recarregando ) { 
                        this.$store.commit('loading', false);
                    }
                });

            } else { 

                if ( this.item.dias.findIndex(dia => dia.selecionado) < 0 ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Selecione os dias da semana desejados.",
                        life: 3000
                    });
                    return;
                }

                this.$util.atualizar (this, { 
                    service: 'agendas',
                    func: 'compor',
                    dados: { 
                        ...this.item,
                        procedimentos: this.procedimentos,  
                        setup: this.setup, 
                    }, 
                    modal: 'agendaEdicaoModal',
                    callback: () => { 
                        this.load(true);
                        this.$emit('refresh');
                    }
                });

            }

        },
        exibir_fora_periodo() { 
            if ( this.fora_periodo && this.fora_periodo.length )
                $('#foraPeriodoModal').modal('show');
        },
        imprimir_fora_periodo() { 
            const configPrint = {
                styles: [
                    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                    "https://api.klingo.app/css/estiloa4l.css",
                ]
            };
            this.$htmlToPaper("impressao-fora-periodo", configPrint, () => {});
            $('#foraPeriodoModal').modal('hide');
        },
        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;

            if ( !this.setup ) { 
                this.$store.commit('setBreadcrumb', this.breadcrumb);
            }
        },
        toggle (item) { 

            this.$store.commit('loading', true);

            let query = { q: [ 
                { 
                    name: 'agenda_grupos.toggle',
                    id: 'toggle',
                    parms: { 
                        ...item,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.toggle.status == 200 ) { 
                        //
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
        medico_inicial (lista, medico) { 

            if ( !lista )
                lista = this.$store.state.options['medicos-cadastro-ativos'];

            if ( lista ) { 
                let item = lista.find(it => { 
                    return it.id_pessoa == medico;
                });

                if ( item ) { 
                    this.medico = item;
                }
            }

        }
    },

    created () { 

        let medico = this.id_medico ? this.id_medico : this.$store.state.contexto.medico;

        if ( medico ) { 

            this.medico = { 
                id_pessoa: isNaN(medico) ? medico.id_pessoa : medico, 
            };

            let lista = this.$store.state.options['medicos-cadastro-ativos'];

            if ( !lista ) { 
                this.loadOptions ('medicos.index', 'medicos-cadastro-ativos')
                    .then(res => { 
                        this.medico_inicial(res, medico);
                    });
            } else { 
                this.medico_inicial(lista, medico);
            }

        } 
        

    },

    mounted () { 

        if ( !this.setup ) { 

           this.$refs['pesquisa'].$refs.input.focus ();

            this.breadcrumb = [
                    { name: "Configurações", path: "/cadastros"},
                    { name: "Agendas", method: this.fechar },
                ];

            this.$store.commit('setBreadcrumb', this.breadcrumb);

        }

        this.$nextTick(() => { 
            this.montando = false;

            if ( !this.medico ) {
                this.load ();
            }
        })

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>